module.exports = __webpack_public_path__ + "img/generated-1772420666796.4cdcc1bd.png";